export default {
    // 默认
    DEFAULT: 0,
    // 独立子公司
    AUTONOMY: 1,
};
